import { useCallback, useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import estrella1Img from "../../../images/estrellas/1estrella.jpg";
import estrella2Img from "../../../images/estrellas/2estrella.jfif";
import estrella3Img from "../../../images/estrellas/3estrella.jfif";
import estrella4Img from "../../../images/estrellas/4estrella.jfif";
import estrella5Img from "../../../images/estrellas/5estrella.jpg";
import estrella6Img from "../../../images/estrellas/6estrella.jfif";
import estrella7Img from "../../../images/estrellas/7estrella.jfif";
import estrella8Img from "../../../images/estrellas/8estrella.jpg";
import estrella9Img from "../../../images/estrellas/9estrella.jpg";
import estrella10Img from "../../../images/estrellas/10estrella.jpg";
import estrella11Img from "../../../images/estrellas/11estrella.jpg";

function buildPlayoffsUrl(item) {
    const params = new URLSearchParams();

    if (item.playoffsTemporada) {
        params.set("temporada", item.playoffsTemporada);
    }

    return `/partidos/playoffs?${params.toString()}`;
}

function buildBuscarPartidoUrl(item) {
    const params = new URLSearchParams();

    if (item.playoffsTemporada) {
        params.set("liga", item.playoffsTemporada);
    }

    return `/partidos/buscarpartido?${params.toString()}`;
}

function splitTitleHighlight(title = "") {
    const match = title.match(/^(.*?)(?:\s—\s|\n)(\d+°\sEstrella)$/);

    if (!match) {
        return { prefix: title, suffix: "" };
    }

    return { prefix: match[1], suffix: match[2] };
}

const starImagesByMarker = {
    "1": estrella1Img,
    "2": estrella2Img,
    "3": estrella3Img,
    "4": estrella4Img,
    "5": estrella5Img,
    "6": estrella6Img,
    "7": estrella7Img,
    "8": estrella8Img,
    "9": estrella9Img,
    "10": estrella10Img,
    "11": estrella11Img,
};

const estrellasTimeline = [
    {
        id: "1940",
        year: "1940",
        marker: "1",
        title: "Federal 1940\n1° Estrella",
        description:
            "El debut fue ante el Campeón vigente Goes y en su propia cancha de la calle Guaviyú. Aguada luego de perder el primer tiempo 15-19 terminó ganando 44 a 41 y el festejo se mantuvo por varios días. Luego de perder tan solo dos partidos en las dos ruedas que se jugaron, el 15 de enero de 1941 en la cancha de Sporting y ante Bohemios como visitante, Aguada obtuvo su primer título Federal tras ganar el partido 35-28.",
        note: "Plantel: Anibal Gardone, Ruben Bulla, Roberto Medrano, Héctor Ruiz, Washington Rodríguez, Juan Bonini, Rolando Marchetti, Victorio Cieslinskas, Hugo Pelufo, Ortiz.\nDT: H. De Luca - H. Di Corcia",
    },
    {
        id: "1941",
        year: "1941",
        marker: "2",
        title: "Federal 1941\n2° Estrella",
        description:
            "En un torneo donde Aguada pierde tan solo 3 partidos (los 3 en nuestra cancha), el 13 de diciembre de 1941 gana como visitante en Welcome ante Goes 36 a 33 para transformarse en Campeón Federal en forma anticipada (3 fechas).",
        note: "Plantel: Bulla, Cieslinskas, Medrano, Ruiz, Rodríguez, Gardone, Bonini, Peluffo, Castro, Anegón, Marchetti, Ortiz, Bruno Rizzo.",
    },
    {
        id: "1942",
        year: "1942",
        marker: "3",
        title: "Federal 1942\n3° Estrella",
        description:
            "Perdiendo tan sólo el último partido del torneo, Aguada se consagra campeón una vez más, de forma anticipada, sacándole a Olimpia, el segundo, 4 puntos de ventaja.",
        note: "Plantel: Cieslinkas, Medrano, Ruiz, Gardone, Rodríguez, Calvo, Peluffo, Marchetti, Ortiz, Rizzo.",
    },
    {
        id: "1943",
        year: "1943",
        marker: "4",
        title: "Federal 1943\n4° Estrella",
        description:
            "En un torneo que resultaría ser el más difícil del cuatrinenio, perdiendo en la primer fecha el clásico y tomando el primer lugar en la penúltima fecha, ganandole a Sporting en la hora, Aguada conseguiría el tan ansiado Cuatrinenio de Oro.",
        note: "Plantel: Calvo, Medrano, Gardone, Cieslinskas, Rodríguez, Marchetti, Cassou, Saldaña, Riet, Ruiz, Rizzo, Faraco.",
    },
    {
        id: "1948",
        year: "1948",
        marker: "5",
        title: "Federal 1948\n5° Estrella",
        description: "Luego de haber completado un Federal de 30 fechas, con dos partidos jugados y ganados en el Estadio Centenario frente a Peñarol y Goes, Aguada pierde tan solo 3 partidos y lograría su Quinta Estrella el 18 de febrero de 1949 en el Parque Central derrotando a Nacional.",
        note: "Plantel: Victorio Cielinskas, León Slazinskas , Gualberto Rodríguez, Carlos Pastorino, Julio Gully, Álvaro Riet, Eugenio Petit, Bruno Rizzo, Antonio Romano, Oscar García, Enrique García, Eduardo Lavignasse, M.Riveiro, Mario Infante, Oscar Grecco, Tabaré Patrón, Ulises Cambre, L. Giorello, y A. Picallo.\nDT: Enrique Calcagno.",
    },
    {
        id: "1974",
        year: "1974",
        marker: "6",
        title: "Federal 1974\n6° Estrella",
        description: "En base a un juego agresivo en la marcación, goleo contundente y una preparación física envidiable, luego de 26 años y con una ventaja de 7 puntos con respecto al segundo, Aguada alcanzaba su Sexta Estrella.",
        note: "Plantel: Jorge Garretano, Mario Viola, Alvaro Santelli, Roberto Vignoli, Andres Bongoll, Walter Vàzquez, Ruben Abal, Eduardo Laborde, Wilfredo Venet, Carlos Fraga, Alvaro Casal, Sergio Martinez, M.Martinez y los hermanos Bulla.",
    },
    {
        id: "1976",
        year: "1976",
        marker: "7",
        title: "Federal 1976\n7° Estrella",
        description: "Un torneo donde se pierden tan solo 4 partidos y se tiene una ventaja sobre el segundo de 4 puntos (Olimpia), Aguada alcanzaría su séptima estrella sin grandes dificultades.",
        note: "Plantel: Jorge Garretano, Mario Viola, Alvaro Santelli, Roberto Vignoli, Walter Vazquez Eugenio Petit, Ruben Abal, Carlos Sanchez, Carlos Kustrin, Alejandro Gonzalez, Néstor Rodriguez, Jorge Tobías, José Acevedo y Álvaro Casal.\nDT: Roberto Pavón.",
    },
    {
        id: "2012-2013",
        year: "2012–2013",
        marker: "8",
        title: "LUB 2012–2013\n8° Estrella",
        showPlantelLink: true,
        showPlayoffsLink: true,
        playoffsTemporada: "LUB 2012-13",
        description: "En una liga en la que Aguada no tuvo una buena temporada regular, termina con un record 20-16 terminaría con el 7° puesto, jugando play-in por un puesto en playoffs contra Olimpia que venía de ser el 10° en la tabla.\n\nAguada comenzaría ganando la serie 1-0 por venir de la Super Liga y se ganaría 3-2 con un partido definitorio en la cancha de Aguada.\n\nLuego nos cruzaríamos con Trouville, quien venía de ganar 15 partidos seguidos y ser el 2° en la tabla. La serie por cuartos de final se ganaría con una barrida 3-0.\n\nLuego vendría Malvín siendo 3°, Aguada derrotó al favorito en 4 partidos, 3-1.\n\nEn la final nos enfrentaríamos a Defensor Sporting, quien había terminado en la 5° posición en la tabla. Fue una final pareja en la que se necesitaron 7 partidos y Aguada ganaría, luego de una sequía de 36 años y varias finales perdidas, el 6 de Mayo de 2013 su tan ansiada 8° estrella.",
        note: "Plantel: Alejandro Muro, Diego González, Gabriel Mino, Gastón Romero, Gonzalo Iglesias, Greg Dilligard, Iván Arbildi, Jeremis Smith, Julio Migliónico, Leandro García Morales, Pablo Ibón, Pablo Morales.\nDT: Javier Espíndola.",
    },
    {
        id: "2018-2019",
        year: "2018–2019",
        marker: "9",
        title: "LUB 2018–2019\n9° Estrella",
        showPlantelLink: true,
        showPlayoffsLink: true,
        playoffsTemporada: "LUB 2018-19",
        description: "Luego de dos ediciones de la Liga Uruguaya donde Aguada disputaría las ultimas dos finales perdiendolas en el séptimo partido, Aguada buscaba revancha.\n\nTerminaría con un récord en temporada regular de 20-11 obteniendo el 1° puesto, nos cruzaríamos contra Defensor Sporting en cuartos de final, ganando la serie 3-1 sin grandes dificultades.\n\nLuego nos cruzaríamos ante Nacional en semifinales por segunda vez consecutiva.\n\nUna vez más, una serie sumamente pareja y terminaríamos ganando la serie 3-2 en un quinto partido decisivo, siendo el primer partido oficial por LUB jugado en el Antel Arena. Sería victoria aguatera y jugamos la tercera final consecutiva.\n\nEn la final nos enfrentamos, por la revancha de la última final, contra Malvín. Luego de ir ganando 3-1, tendríamos que ir a un 7° partido definitorio para definir el campeonato. En un partido parejo que se termina resolviendo en las últimas jugadas, el 6 de Mayo de 2019, Aguada logra su 9° estrella y el primero en la historia en salir campeon en el Antel Arena.",
        note: "Plantel: Al Thornton, Alfonso Arrillaga, Andrew Feeley, Demian Álvarez, Dwayne Davis, Federico Bavosi, Federico Pereiras, Ignacio Núñez, Joaquín Rodríguez, Leandro Taboada, Nahuel Lemos, Nahuel Santos, Sebastián Izaguirre, Zach Graham.\nDT: Miguel Volcan. AT: Germán Cortizas.",
    },
    {
        id: "2019-2020",
        year: "2019–2020",
        marker: "10",
        title: "LUB 2019–2020\n10° Estrella",
        showPlantelLink: true,
        showPlayoffsLink: true,
        playoffsTemporada: "LUB 2019-20",
        description: "Un campeonato recordado porque duró un año y cuatro meses a raíz de la pandemia mundial por el Coronavirus, Aguada una vez más sería protagonista.\n\nEn una temporada regular llena de suspensiones y jugadores en cuarentena debido a la emergencia sanitaria, Aguada terminaría con un record de 19-9, obteniendo el 7° puesto.\n\nNos enfrentamos en Cuartos de Final a un Olimpia que había sorprendido y terminado con el 2° puesto. Sería una serie controlada por Aguada, ganandola 3-1. Luego, una vez más, y por 5 vez consecutiva y 3 en semifinal, nos enfrentaríamos a Nacional en semifinales. Y una vez más, sería una serie pareja y con victoria nuevamente aguatera 3-2.\n\nEn una final que sería al mejor de 5, nos enfrentaríamos a Trouville, quien no fue obstaculo para Aguada y terminaría ganando la serie 3-1. Es así como el 26 de Febrero de 2021, Aguada obtiene su 10° estrella.",
        note: "Plantel: Agustín Viotti, Al Thornton, Dwayne Davis, Federico Bavosi, Federico Pereiras, Ignacio Castro, Joaquín Silveira, Leandro García Morales, Lee Roberts, Lucas Silva, Martín Garay, Mateo Sarni, Nahuel Santos, Sebastián Izaguirre.\nDT: Adrián Capelli.",
    },
    {
        id: "2023-2024",
        year: "2023–2024",
        marker: "11",
        title: "LUB 2023–2024\n11° Estrella",
        showPlantelLink: true,
        showPlayoffsLink: true,
        playoffsTemporada: "LUB 2023-24",
        description: "En una temporada regular donde jugamos 32 partidos, ganando 24 y perdiendo solo 8, obtuvieramos la 2° posición en la tabla.\n\nNos enfrentaríamos ante Malvín en Cuartos de Final, ganando la serie comodamente 3-0 para clasificar a la Semifinales.\n\nEn semis nos enfrentaríamos, una vez más, ante Nacional. Sería nuevamente victoria aguatera en la serie, 3-1.\n\nEn la final nos enfrentaríamos ante Peñarol, jugando los primeros 4 partidos en cancha de los clubes y el 5°, el cual sería el último de la serie en el Antel Arena. Sería en ese 5° partido, el 17 del Junio del 2024 que Aguada obtendría su 11° estrella.",
        note: "Plantel: Agustín Gentile, Agustín Zuvich, Bruno Curadossi, Diego García, Diego Pena García, Donald Sims, Facundo Villalba, Federico Pereiras, Juan Santiso, Juan Stoll, Luís Santos, Manuel Fernández, Santiago Vidal, Victor Rudd.",
    },
];

function EstrellasTimeline() {
    const timelineItems = useMemo(() => [...estrellasTimeline].reverse(), []);
    const modalItems = useMemo(
        () => timelineItems.filter((item) => Boolean(starImagesByMarker[item.marker])),
        [timelineItems]
    );
    const [activeModalIndex, setActiveModalIndex] = useState(null);

    const isModalOpen = activeModalIndex !== null;
    const modalItem = isModalOpen ? modalItems[activeModalIndex] : null;
    const modalImage = modalItem ? starImagesByMarker[modalItem.marker] : null;
    const { prefix: modalPrefix, suffix: modalSuffix } = splitTitleHighlight(modalItem?.title ?? "");

    const openModalForItem = (itemId) => {
        const index = modalItems.findIndex((item) => item.id === itemId);
        if (index !== -1) {
            setActiveModalIndex(index);
        }
    };

    const closeModal = useCallback(() => {
        setActiveModalIndex(null);
    }, []);

    const showPrev = useCallback(() => {
        setActiveModalIndex((prev) => {
            if (prev === null) {
                return prev;
            }

            return prev === 0 ? modalItems.length - 1 : prev - 1;
        });
    }, [modalItems.length]);

    const showNext = useCallback(() => {
        setActiveModalIndex((prev) => {
            if (prev === null) {
                return prev;
            }

            return prev === modalItems.length - 1 ? 0 : prev + 1;
        });
    }, [modalItems.length]);

    useEffect(() => {
        if (!isModalOpen) {
            return undefined;
        }

        const previousBodyOverflow = document.body.style.overflow;
        const previousHtmlOverflow = document.documentElement.style.overflow;
        document.body.style.overflow = "hidden";
        document.documentElement.style.overflow = "hidden";

        const onKeyDown = (event) => {
            if (event.key === "Escape") {
                closeModal();
            }

            if (event.key === "ArrowLeft") {
                showPrev();
            }

            if (event.key === "ArrowRight") {
                showNext();
            }
        };

        window.addEventListener("keydown", onKeyDown);

        return () => {
            document.body.style.overflow = previousBodyOverflow;
            document.documentElement.style.overflow = previousHtmlOverflow;
            window.removeEventListener("keydown", onKeyDown);
        };
    }, [isModalOpen, closeModal, showPrev, showNext]);

    return (
        <section className="relative overflow-hidden pb-8">
            <div className="absolute left-1/2 top-0 hidden h-full w-px -translate-x-1/2 bg-gradient-to-b from-green-400/0 via-green-400/70 to-red-400/70 md:block" />

            <div className="space-y-16 md:space-y-24">
                {timelineItems.map((item, index) => {
                    const isLeft = index % 2 === 0;
                    const { prefix, suffix } = splitTitleHighlight(item.title);
                    const starImage = starImagesByMarker[item.marker];
                    return (
                        <article key={item.id} className="relative flex flex-col items-center md:flex-row">
                            <div className={`flex-1 mt-8 md:mt-0 md:order-1 ${isLeft ? "order-3 md:pr-12 md:text-right" : "order-2 md:pr-12"}`}>
                                {isLeft ? (
                                    <div className="relative overflow-hidden rounded-2xl border border-white/20 border-l-2 border-l-green-500/70 bg-white/5 p-6 shadow-2xl backdrop-blur-xl">
                                        <span className="pointer-events-none absolute left-0 top-0 h-0.5 w-1/2 bg-green-400"></span>
                                        <span className="pointer-events-none absolute bottom-0 right-0 h-0.5 w-1/3 bg-red-500"></span>
                                        <h3 className="mb-3 text-lg font-black text-white sm:text-xl">
                                            <span className="block whitespace-pre-line text-green-300">{prefix}</span>
                                            {suffix && <span className="block text-red-400">{suffix}</span>}
                                        </h3>
                                        <p className="mb-4 text-[15px] leading-7 text-slate-300" style={{whiteSpace: "pre-line"}}>{item.description}</p>
                                        {(item.showPlantelLink || item.showPlayoffsLink || item.playoffsTemporada) && (
                                            <div className="mt-4 flex flex-wrap gap-2 md:justify-end">
                                                {item.showPlantelLink && (
                                                    <Link
                                                        to="/perfiles/planteles?campeones=1"
                                                        className="inline-flex items-center justify-center px-4 py-2 rounded-lg border border-green-500/40 bg-green-500/10 text-green-200 text-xs sm:text-sm font-black uppercase tracking-wide hover:bg-green-500 hover:text-white hover:border-green-400 transition-all duration-200"
                                                    >
                                                        Ver plantel
                                                    </Link>
                                                )}
                                                {item.showPlayoffsLink && (
                                                    <Link
                                                        to={buildPlayoffsUrl(item)}
                                                        className="inline-flex items-center justify-center px-4 py-2 rounded-lg border border-green-500/40 bg-green-500/10 text-green-200 text-xs sm:text-sm font-black uppercase tracking-wide hover:bg-green-500 hover:text-white hover:border-green-400 transition-all duration-200"
                                                    >
                                                        Ver playoffs
                                                    </Link>
                                                )}
                                                {item.playoffsTemporada && (
                                                    <Link
                                                        to={buildBuscarPartidoUrl(item)}
                                                        className="inline-flex items-center justify-center px-4 py-2 rounded-lg border border-green-500/40 bg-green-500/10 text-green-200 text-xs sm:text-sm font-black uppercase tracking-wide hover:bg-green-500 hover:text-white hover:border-green-400 transition-all duration-200"
                                                    >
                                                        Ver partidos
                                                    </Link>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ) : (starImage || item.note) ? (
                                    <div className="w-full max-w-md space-y-3">
                                        {starImage && (
                                            <button
                                                type="button"
                                                onClick={() => openModalForItem(item.id)}
                                                className="w-full cursor-pointer overflow-hidden rounded-xl border border-white/15 bg-[#0b2116] p-2 shadow-xl shadow-black/20"
                                                aria-label={`Ver imagen ampliada de la estrella ${item.marker}`}
                                            >
                                                <img
                                                    src={starImage}
                                                    alt={`Estrella ${item.marker} de Aguada`}
                                                    loading="lazy"
                                                    className="aspect-[4/3] w-full rounded-lg object-cover"
                                                />
                                            </button>
                                        )}
                                        {item.note && (
                                            <p className={`text-sm italic ${item.noteClass ?? "text-slate-400 font-semibold"}`} style={{ whiteSpace: "pre-line" }}>
                                                {item.note}
                                            </p>
                                        )}
                                    </div>
                                ) : null}
                            </div>

                            <div className="relative z-10 order-1 flex h-20 w-20 shrink-0 items-center justify-center md:order-2">
                                <svg className="absolute inset-0 w-full h-full" viewBox="0 0 100 100" aria-hidden="true">
                                    <path
                                        d="M50 4 L62 36 L96 36 L68 56 L78 90 L50 70 L22 90 L32 56 L4 36 L38 36 Z"
                                        fill="#14532d"
                                        stroke="#ef4444"
                                        strokeWidth="4"
                                    />
                                </svg>
                                <div className="absolute inset-0 flex items-center justify-center px-2 text-lg font-black text-white">
                                    {item.marker}
                                </div>
                            </div>

                            <div className={`flex-1 mt-8 md:mt-0 md:order-3 md:pl-12 ${isLeft ? "order-2" : "order-3"}`}>
                                {!isLeft ? (
                                    <div className="relative overflow-hidden rounded-2xl border border-white/20 border-l-2 border-l-green-500/70 bg-white/5 p-6 shadow-2xl backdrop-blur-xl">
                                        <span className="pointer-events-none absolute left-0 top-0 h-0.5 w-1/2 bg-green-400"></span>
                                        <span className="pointer-events-none absolute bottom-0 right-0 h-0.5 w-1/3 bg-red-500"></span>
                                        <h3 className="mb-3 text-lg font-black text-white sm:text-xl">
                                            <span className="block whitespace-pre-line text-green-300">{prefix}</span>
                                            {suffix && <span className="block text-red-400">{suffix}</span>}
                                        </h3>
                                        <p className="mb-4 text-[15px] leading-7 text-slate-300" style={{whiteSpace: "pre-line"}}>{item.description}</p>
                                        {(item.showPlantelLink || item.showPlayoffsLink || item.playoffsTemporada) && (
                                            <div className="mt-4 flex flex-wrap gap-2">
                                                {item.showPlantelLink && (
                                                    <Link
                                                        to="/perfiles/planteles?campeones=1"
                                                        className="inline-flex items-center justify-center px-4 py-2 rounded-lg border border-green-500/40 bg-green-500/10 text-green-200 text-xs sm:text-sm font-black uppercase tracking-wide hover:bg-green-500 hover:text-white hover:border-green-400 transition-all duration-200"
                                                    >
                                                        Ver plantel
                                                    </Link>
                                                )}
                                                {item.showPlayoffsLink && (
                                                    <Link
                                                        to={buildPlayoffsUrl(item)}
                                                        className="inline-flex items-center justify-center px-4 py-2 rounded-lg border border-green-500/40 bg-green-500/10 text-green-200 text-xs sm:text-sm font-black uppercase tracking-wide hover:bg-green-500 hover:text-white hover:border-green-400 transition-all duration-200"
                                                    >
                                                        Ver playoffs
                                                    </Link>
                                                )}
                                                {item.playoffsTemporada && (
                                                    <Link
                                                        to={buildBuscarPartidoUrl(item)}
                                                        className="inline-flex items-center justify-center px-4 py-2 rounded-lg border border-green-500/40 bg-green-500/10 text-green-200 text-xs sm:text-sm font-black uppercase tracking-wide hover:bg-green-500 hover:text-white hover:border-green-400 transition-all duration-200"
                                                    >
                                                        Ver partidos
                                                    </Link>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                ) : (starImage || item.note) ? (
                                    <div className="w-full max-w-md space-y-3">
                                        {starImage && (
                                            <button
                                                type="button"
                                                onClick={() => openModalForItem(item.id)}
                                                className="w-full cursor-pointer overflow-hidden rounded-xl border border-white/15 bg-[#0b2116] p-2 shadow-xl shadow-black/20"
                                                aria-label={`Ver imagen ampliada de la estrella ${item.marker}`}
                                            >
                                                <img
                                                    src={starImage}
                                                    alt={`Estrella ${item.marker} de Aguada`}
                                                    loading="lazy"
                                                    className="aspect-[4/3] w-full rounded-lg object-cover"
                                                />
                                            </button>
                                        )}
                                        {item.note && (
                                            <p className={`text-sm italic ${item.noteClass ?? "text-slate-400 font-semibold"}`} style={{ whiteSpace: "pre-line" }}>
                                                {item.note}
                                            </p>
                                        )}
                                    </div>
                                ) : null}
                            </div>
                        </article>
                    );
                })}
            </div>

            <AnimatePresence mode="wait">
                {isModalOpen && modalItem && modalImage && (
                    <motion.div
                        className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-3 sm:p-6"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.2 }}
                        onClick={closeModal}
                    >
                        <motion.div
                            className="relative w-full max-w-6xl"
                            initial={{ scale: 0.95, opacity: 0, y: 10 }}
                            animate={{ scale: 1, opacity: 1, y: 0 }}
                            exit={{ scale: 0.95, opacity: 0, y: 10 }}
                            transition={{ duration: 0.3, ease: "easeOut" }}
                            onClick={(event) => event.stopPropagation()}
                        >
                        <div className="relative w-full max-h-[92vh] overflow-hidden rounded-xl border border-white/20 bg-[#0b1a12] p-4 pt-14 sm:p-6 sm:pt-14">

                            <button
                                type="button"
                                onClick={closeModal}
                                className="absolute right-3 top-3 h-9 w-9 rounded-full border border-white/20 bg-black/30 text-white hover:bg-black/50 z-30"
                                aria-label="Cerrar modal"
                            >
                                x
                            </button>

                            <div className="grid gap-5 md:grid-cols-2 md:gap-8 md:items-center">
                                <div className="space-y-4 md:h-[78vh] md:flex md:flex-col md:justify-center">
                                    <img
                                        src={modalImage}
                                        alt={`Estrella ${modalItem.marker} de Aguada ampliada`}
                                        className="w-full max-h-[42vh] md:max-h-[78vh] rounded-xl border border-white/20 object-contain bg-black/20"
                                    />
                                    <div className="flex items-center justify-center gap-4">
                                        <button
                                            type="button"
                                            onClick={showPrev}
                                            className="h-9 w-9 rounded-full border border-white/20 bg-black/50 text-white hover:bg-black/70"
                                            aria-label="Imagen anterior"
                                        >
                                            &lt;
                                        </button>
                                        <span className="text-xs sm:text-sm text-slate-300 font-semibold">
                                            {activeModalIndex + 1} / {modalItems.length}
                                        </span>
                                        <button
                                            type="button"
                                            onClick={showNext}
                                            className="h-9 w-9 rounded-full border border-white/20 bg-black/50 text-white hover:bg-black/70"
                                            aria-label="Imagen siguiente"
                                        >
                                            &gt;
                                        </button>
                                    </div>
                                </div>

                                <div className="space-y-4 overflow-y-auto max-h-[36vh] md:max-h-[78vh] pr-1">
                                    <h3 className="text-green-400 text-xl sm:text-2xl font-bold">
                                        <span className="block whitespace-pre-line text-green-300">{modalPrefix}</span>
                                        {modalSuffix && <span className="block text-red-400">{modalSuffix}</span>}
                                    </h3>
                                    <p className="text-slate-200" style={{ whiteSpace: "pre-line" }}>
                                        {modalItem.description}
                                    </p>
                                    {modalItem.note && (
                                        <p
                                            className={`text-sm italic ${modalItem.noteClass ?? "text-slate-400 font-semibold"}`}
                                            style={{ whiteSpace: "pre-line" }}
                                        >
                                            {modalItem.note}
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
}

export default EstrellasTimeline;
